import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AuthStoreEffects } from './effects';
import { featureReducer } from './reducer';

export function provideAuthStore() {
  return [
    provideState('Auth', featureReducer),
    provideEffects([AuthStoreEffects]),
  ];
}
